import { RootState } from 'editor/src/store/index';

const isUseNotUploadedImagesAllowed = (state: RootState) => state.hostSettings.allowUseNotUploadedImages;

export default isUseNotUploadedImagesAllowed;
